import ServiceHandler from '../../../services/service-handler';

export default function getNumberFormatByRegion(mileage = '') {
    const {
        currentLanguageRegionCode,
    } = ServiceHandler.AppConfigurationService;
    return Number(mileage).toLocaleString(currentLanguageRegionCode);
}
